import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@material-ui/core/TablePagination'; 
import TextField from '@mui/material/TextField';
import Radio from '@mui/material/Radio';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import pageimg from './images/attendance.png';
import GolfCourseIcon from '@mui/icons-material/GolfCourse';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,DatePicker, 
  KeyboardDatePicker,
  DateTimePicker
} from '@material-ui/pickers';
import calenderimg from './images/calender-icon.png';
import { addDays } from "date-fns";
import Grid from '@material-ui/core/Grid';
import ReactToPrint from 'react-to-print';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Moment from 'react-moment';
import moment from 'moment';

const headCells = [
   
  { id: 'ur_name', numeric: false,  label: 'Teacher' },
   { id: 'sb_title', numeric: false,  label: 'Subject' },
   
      { id: 'tc_title', numeric: false,  label: 'Class' },
{ id: 'poa_startdate', numeric: false,  label: 'Portion Assigned Date' },
{ id: 'poa_enddate', numeric: false,  label: 'To Date' },
{ id: 'pst_starteddate', numeric: false,  label: 'Portion Started Date' },

{ id: 'pst_endeddate', numeric: false,  label: 'Portion Ended Date' },
{ id: 'pst_status', numeric: false,  label: 'Status' },
{ id: 'pst_reason', numeric: false,  label: 'Reason' },

  ]

  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

function formatDate(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date)) return '';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); 
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});



export default class SyllabusStatusReport extends Component {
	
    constructor(props) {
    super(props);
	
	var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
   
      this.state = {redirect: false,
	  poa_startdate:Date.now()
	  ,poa_enddate:Date.now(),pst_status:'',pststatus:'',
      portionstsdata:[],page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
order:'desc' ,orderBy:'',Classarr:[],classlabel:'Select Class', classid:'',
	   poa_sb_id:'',subarr:[],sublabel:'Select Subject',syllabus:'', 
	   poa_enddate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),
	   poa_startdate1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(), 
	   
      }
       this.updateDonenewParent = this.updateDonenewParent;
	 this.componentRef = React.createRef();  
	   
	}
	
	  handleassignedDateChange = (date) => {
	
	  var month="";
	 
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({ poa_startdate:date,
poa_startdate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }
  handledueDateChange = (date) => {
	
	  var month="";
	 
	 if((date.getMonth() + 1)<10)
	 {
		month="0"+ (date.getMonth() + 1)		 
	 }else{month=(date.getMonth() + 1)}   
	 
     this.setState({ poa_enddate:date,
poa_enddate1:date.getFullYear() + '-' + month + '-' +date.getDate()
	 })
	
	
  }
	
	
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,
	  portionstsdata:[],
    });
	 this.apicall(this.state.page, this.state.rowsPerPage);
//this.componentDidMount();  
}
	





	componentWillMount() {
	
	
	document.title = "MM Coching Center - Portion Status Report";
	
	if(localStorage.getItem("MMCuserid")==null)

		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
	
	
	
	
	  localStorage.setItem("page",this.state.rowsPerPage)
	  
	 /* this.setState({ branchid: localStorage.getItem("MMCbranchid") }, () => {
  this.subBind();
});*/

  this.apicall(this.state.page,this.state.rowsPerPage);
 
  
  //this.ClassBind();
  //this.subBind();
} 


subBind(){

    axios.get(Serverurl+'ajaxsubjects.php?action=getall&sb_class_id='+this.state.classid+'&sb_syllabustype='+this.state.syllabus)
	
    
      .then((response) => {    
     
      this.setState({  subarr: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.subarr.map(sub => {
                            
          return {value: sub.sb_id, display:sub.sb_title}
        });
      
		
        this.setState({
          subarr: [{value: '', display: 'Select Subject'}].concat(roleFromApi)
        });
      })


}

 


ClassBind()
{
	axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=2')
       .then(resp => { 		
			if(resp.data.length>0){
				this.setState({
						Classarr:resp.data	
							}) 
			}

	   }) .then(data => {
        let classFromApi = this.state.Classarr.map(row => {
                          
          return {value: row.tc_id, display:row.tc_title}
        });
      
		
        this.setState({
          Classarr: [{value: '0', display: 'Select Class'}].concat(classFromApi)
        });
      })

}

handleClickSearch=()=>{   

  this.apicall(this.state.page,this.state.rowsPerPage); 
//this.ClassBind();
	
} 


myChangeHandler = (event) => {
  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
  this.setState({
        [nam]: val
    },()=>{
		if(nam==="classid")
		{
			//this.batchbind();
	this.subBind();
		}else if(nam==="syllabus")
		{
			//this.batchbind();
			this.ClassBind();
	
		}	
		
		
	});
 
}




  
apicall(page,rowsPerPage){
	
	
				
	 axios.get(Serverurl+'ajaxportionsassigned.php?action=portionreport&poa_sb_id='+this.state.poa_sb_id+'&StartIndex='+page+'&PageSize='+rowsPerPage+'&pst_status='+this.state.pst_status+'&poa_startdate='+this.state.poa_startdate1+'&poa_enddate='+this.state.poa_enddate1)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  portionstsdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
			let copy=[50, 100, 150, 200, 250];
			
	  
	  this.setState({rowsPaging:copy});
	 
     }
	 else{
		   this.setState({portionstsdata:[],totaldata:0});
	 }
 
    });
}



handleChangePage = (event, newPage) => {  
   
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  };  
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
    localStorage.setItem("page",pageval)

    setTimeout(() =>  this.componentDidUpdate() ,500);
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};




	  
     /* Assignaddbox(val){
        this.setState({ as_id: val });  
  
         setTimeout(() => this.refs.AddAssigntBox.handleClickOpen(),500);

      }*/

render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
   
<div className="containermain">
<div className="boxheading">
				  <div className="contntpad">
<h2><img src={pageimg}/>Portion Status Report</h2>
</div></div>

   <div className="searchmaster">


  
  <ul>
  
		 <li><p><span className="validation">*</span> Syllabus Type</p>
	  <Radio
        checked={this.state.syllabus === '2'}
        onChange={this.myChangeHandler}
        value="2"
        name="syllabus"
        inputProps={{ 'aria-label': 'B' }}
      />State<Radio
        checked={this.state.syllabus === '1'}
        onChange={this.myChangeHandler}
        value="1"
        name="syllabus"
        inputProps={{ 'aria-label': 'A' }}
      />CBSE
    <Radio
        checked={this.state.syllabus === '3'}
        onChange={this.myChangeHandler}
        value="3"
        name="syllabus"
        inputProps={{ 'aria-label': 'A' }}
      />PUC

	  
	 </li>
	
<li><p><span className="validation">*</span>Class</p>
	  <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.classlabel, value: this.state.classid }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.classid}
		  name="classid"
		
		
        >
		{this.state.Classarr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
	  
	  </li> 
	<li>
	<p> Subject <span className="validationtxt"></span></p>
	 <p>
	  <FormControl fullWidth  size="small">
       
        <Select
         native
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.sublabel, value: this.state.poa_sb_id }}
          onChange={this.myChangeHandler}
          id="state"
		   value={this.state.poa_sb_id}
		  name="poa_sb_id"
		
		
        >
		{this.state.subarr.map(row => (
            <option  
            
              value={row.value}
            >
              {row.display}
            </option  >
          ))}
		
        </Select>
 </FormControl></p>
</li>

<li>
<p> Start Date. <span className="validationtxt"></span></p>
 <p>
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justify="space-around">
	 
      <DatePicker fullWidth
        value={this.state.poa_startdate}
        onChange={this.handleassignedDateChange}
		
            format="dd/MM/yyyy"
        autoOk name="poa_startdate"
        ampm={false} inputVariant="outlined"
      />
	   </Grid>
    </MuiPickersUtilsProvider>
		</p></li>
		
		
	<li>
<p> End Date. <span className="validationtxt"></span></p>
 <p>
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
      <Grid container justify="space-around">
	 
      <DatePicker fullWidth
        value={this.state.poa_enddate}
        onChange={this.handledueDateChange}
		
            format="dd/MM/yyyy"
        autoOk name="poa_enddate"
        ampm={false} inputVariant="outlined"
      />
	   </Grid>
    </MuiPickersUtilsProvider>
		</p></li>
		
		<li>
  <p>Status <span className="validationtxt"></span></p>
  <p>
    <FormControl fullWidth size="small">
      <Select
        native
        variant="outlined"
        margin="normal"
        value={this.state.pst_status}
        onChange={this.myChangeHandler}
        name="pst_status"
      >
        <option value={""}>All</option>
		<option value={1}>In Progress</option>
<option value={2}>Completed</option>
      </Select>
    </FormControl>
  </p>
</li>

	
	
	
		</ul>
		<div className="searchnewbtn">
		<p className="searchbutton">
		<Button variant="contained" disabled={this.state.btndisabled} onClick={this.handleClickSearch} className={useStyles.submit} endIcon={<SearchIcon />}>
			Search
      </Button>&nbsp;&nbsp;<ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className="exportbtn"
                    table="portionreport"
                    filename="Portion Status Report"
                    sheet="Portion Report"
                    buttonText="Export"/>&nbsp;&nbsp;<ReactToPrint 
            trigger={() => <p id="print-button" className="exportbtn">Print </p>}
			content={() =>  this.componentRef} /></p>
		</div>	
		
		
		
		
		
</div>		



<div ref={el => (this.componentRef = el)}>
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table id="portionreport" stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.portionstsdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.portionstsdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.ur_name}</TableCell>
<TableCell>{item.sb_title}</TableCell>
<TableCell>{item.tc_title}</TableCell>

<TableCell>{formatDate(item.poa_startdate)}</TableCell>
<TableCell>{formatDate(item.poa_enddate)}</TableCell>
<>
  <TableCell>{item.pst_starteddate ? formatDate(item.pst_starteddate) : ''}</TableCell>
  <TableCell>{item.pst_endeddate ? formatDate(item.pst_endeddate) : ''}</TableCell>
  <TableCell>{item.pststatus || ''}</TableCell>
  <TableCell>{item.pst_reason || ''}</TableCell>
</>

	{/*<TableCell>{formatDate(item.pst_starteddate)}</TableCell>
<TableCell>{formatDate(item.pst_endeddate)}</TableCell>
<TableCell>{item.pststatus}</TableCell>
	<TableCell>{item.pst_reason}</TableCell>*/}


 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colSpan="5">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[50, 100, 150, 200, 250]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />   
  </Paper>
    
</div></div>
 </React.Fragment> 

 
 
  );
}
}


